import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerReligion = async () => axios.get(Routes.CUSTOMER_RELIGION);

export const useCustomerReligion = () =>
  useQuery({
    queryKey: [Keys.CUSTOMER_RELIGION_QRY],
    queryFn: customerReligion,
  });
